<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <img v-if="isMobile" src="@/assets/ap-logo.png" class="sidebar-logo" />
    <breadcrumb v-if="!isMobile" id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <!-- <DateTime></DateTime> -->
      <!-- <div class="version">
        <el-tag size="mini" type="danger" class="tag-env">{{ env.toUpperCase() }} 版本</el-tag>
      </div> -->
      <template v-if="!isMobile">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

        <div v-if="showMerchantRtpSetter" class="merchant-rtp">
          <span class="label">商户RTP</span>
          <template v-if="!merchantRtpEditing">
            <span class="value">{{ merchantRtpLoading ? '--' : merchantRtp }}</span>
            <el-button
              icon="el-icon-edit"
              type="text"
              :disabled="merchantRtpLoading || merchantRtpSubmitting"
              @click="startEditMerchantRtp"
            ></el-button>
          </template>
          <template v-else>
            <el-input-number
              style="width: 90px"
              v-model="merchantRtpDraft"
              size="mini"
              :min="0"
              :max="97"
              :controls="true"
              controls-position="right"
              class="input"
            />
            <div class="button-group">
              <el-button
                type="text"
                size="small"
                :loading="merchantRtpSubmitting"
                :disabled="merchantRtpSubmitting"
                @click="submitMerchantRtp"
                >保存
              </el-button>

              <el-button type="text" size="small" :disabled="merchantRtpSubmitting" @click="cancelEditMerchantRtp"
                >取消</el-button
              >
            </div>
          </template>
        </div>

        <NavbarTimezoneClocks />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <svg-icon icon-class="user" class="user-avatar" /> -->
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <!-- <i class="user-icon el-icon-user-solid mr-1" /> -->
          <svg-icon class="user-icon mr-2" icon-class="user-circle" />
          <div v-if="!isMobile" class="user-name mr-1">
            {{ name }} <el-tag size="mini">{{ roleName }}</el-tag>
          </div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/profile/index">
            <el-dropdown-item>Profile</el-dropdown-item>
          </router-link> -->
          <!-- <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link> -->
          <!-- <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a> -->
          <!-- <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a> -->
          <el-dropdown-item v-if="isMobile">
            <div class="user-name mr-1">
              {{ name }} <el-tag size="mini">{{ roleName }}</el-tag>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import NavbarTimezoneClocks from './NavbarTimezoneClocks.vue'
import { getMerchantRtp, setMerchantRtp } from '@/api/gameManage/merchantRtp'
// import DateTime from './Datetime.vue';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    NavbarTimezoneClocks,
    Screenfull,
    // DateTime,
  },
  data() {
    return {
      merchantRtp: 0,
      merchantRtpDraft: 0,
      merchantRtpEditing: false,
      merchantRtpLoading: false,
      merchantRtpLoaded: false,
      merchantRtpSubmitting: false,
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name', 'roles', 'device', 'env']),
    isMobile() {
      return this.device === 'mobile'
    },
    roleName() {
      const mapper = { admin: '管理员', agent: '代理', merchant: '商户' }
      return mapper[this.roles[0]]
    },
    showMerchantRtpSetter() {
      const role = this.roles?.[0]
      return role === 'admin' || role === 'merchant'
    },
  },
  watch: {
    showMerchantRtpSetter: {
      immediate: true,
      handler(v) {
        if (!v) return
        if (this.isMobile) return
        this.loadMerchantRtp()
      },
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async loadMerchantRtp() {
      if (this.merchantRtpLoaded) return
      if (this.merchantRtpLoading || this.merchantRtpSubmitting) return
      this.merchantRtpLoading = true
      try {
        const res = await getMerchantRtp()
        const rtp = Number(res?.data?.rtp)
        if (!Number.isNaN(rtp)) {
          this.merchantRtp = rtp
          if (!this.merchantRtpEditing) {
            this.merchantRtpDraft = rtp
          }
        }
        this.merchantRtpLoaded = true
      } catch (e) {
        // request.js 已统一 toast，这里不重复提示
      } finally {
        this.merchantRtpLoading = false
      }
    },
    startEditMerchantRtp() {
      this.merchantRtpDraft = Number(this.merchantRtp) || 0
      this.merchantRtpEditing = true
    },
    cancelEditMerchantRtp() {
      if (this.merchantRtpSubmitting) return
      this.merchantRtpEditing = false
      this.merchantRtpDraft = Number(this.merchantRtp) || 0
    },
    async submitMerchantRtp() {
      if (this.merchantRtpSubmitting) return
      const n = Number(this.merchantRtpDraft)
      if (Number.isNaN(n) || n < 0 || n > 97) {
        this.$message?.warning?.('RTP范围需在0-97')
        return
      }
      this.merchantRtpSubmitting = true
      try {
        const res = await setMerchantRtp({ rtp: n })
        if (res.code === 0) {
          this.merchantRtp = n
          this.merchantRtpEditing = false
          this.$message?.success?.('商户RTP设置成功')
        }
      } catch (e) {
        // request.js 已统一 toast，这里不重复提示
      } finally {
        this.merchantRtpSubmitting = false
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      this.$router.push('/login')
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);
  border-bottom: 1px solid rgba(0, 21, 41, 0.08);

  .sidebar-logo {
    width: 36px;
    height: 36px;
    vertical-align: middle;
    margin-right: 12px;
    margin-top: 7px;
  }

  .version {
    height: 100%;
    display: inline-flex;
    margin-right: 12px;
    align-items: center;
    .tag-env {
      color: #fd0000;
      font-weight: 800;
    }
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .merchant-rtp {
      background-color: #f0f2f5;
      padding: 0px 8px;
      display: inline-flex;
      align-items: center;
      margin-right: 10px;
      gap: 6px;

      .label {
        font-size: 12px;
        color: #606266;
        white-space: nowrap;
      }
      .value {
        font-size: 12px;
        color: #303133;
        font-weight: 600;
        min-width: 20px;
        text-align: right;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .input {
        width: 120px;
      }
      .button-group {
        flex-direction: row;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        button {
          margin: 0;
        }
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 10px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        line-height: 0;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .user-icon {
          font-size: 28px;
        }

        .user-name {
          cursor: pointer;
          font-size: 14px;
          line-height: 1;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          // position: absolute;
          // right: -20px;
          // top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
